/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import actionCreatorFactory from 'typescript-fsa';
import { GroupHighscore, UserGroupDefaultHighscoreRound } from '../../services/betting';

const actionCreator = actionCreatorFactory();

export const setGroupHighscores = actionCreator<GroupHighscore[]>('SET_GROUP_HIGHSCORES');

export interface GroupHighscorePagingValues {
    count: number;
    current: number;
    forwardEnabled: boolean;
    backwardEnabled: boolean;
}
export const SET_GROUP_HIGHSCORES_PAGING_VALUES: string = 'SET_GROUP_HIGHSCORES_PAGING_VALUES';
export const setGroupHighscoresPagingValues =
    actionCreator<GroupHighscorePagingValues>(SET_GROUP_HIGHSCORES_PAGING_VALUES);

export const setGroupHighscoreSearchString = actionCreator<string>('SET_GROUP_HIGHSCORES_SEARCH_STRING');

export const FETCH_GROUP_HIGHSCORES: string = 'FETCH_GROUP_HIGHSCORES';
export const fetchGroupHighscore = actionCreator(FETCH_GROUP_HIGHSCORES);

export const SEARCH_GROUP_HIGHSCORES: string = 'SEARCH_GROUP_HIGHSCORES';
export const searchGroupHighscores = actionCreator<string>(SEARCH_GROUP_HIGHSCORES);

export const PAGE_UP_GROUP_HIGHSCORES: string = 'PAGE_UP_GROUP_HIGHSCORES';
export const pageUpGroupHighscores = actionCreator(PAGE_UP_GROUP_HIGHSCORES);

export const PAGE_DOWN_GROUP_HIGHSCORES: string = 'PAGE_DOWN_GROUP_HIGHSCORES';
export const pageDownGroupHighscores = actionCreator(PAGE_DOWN_GROUP_HIGHSCORES);

export const PAGE_LAST_GROUP_HIGHSCORES: string = 'PAGE_LAST_GROUP_HIGHSCORES';
export const pageLastGroupHighscores = actionCreator(PAGE_LAST_GROUP_HIGHSCORES);

export const PAGE_FIRST_GROUP_HIGHSCORES: string = 'PAGE_FIRST_GROUP_HIGHSCORES';
export const pageFirstGroupHighscores = actionCreator(PAGE_FIRST_GROUP_HIGHSCORES);

export const GROUP_HIGHSCORES_SET_TR_ID = 'GROUP_HIGHSCORES_SET_TR_ID';
export const groupHighscoresSetTrId = actionCreator<string>(GROUP_HIGHSCORES_SET_TR_ID);

export const GROUP_HIGHSCORES_LOAD_WITHOUT_PROPS = 'GROUP_HIGHSCORES_LOAD_WITHOUT_PROPS';
export const groupHighscoresLoadWithoutProps = actionCreator(GROUP_HIGHSCORES_LOAD_WITHOUT_PROPS);

export const HIGHSCORES_LOAD_WITHOUT_PROPS = 'HIGHSCORES_LOAD_WITHOUT_PROPS';
export const highscoresLoadWithoutProps = actionCreator(HIGHSCORES_LOAD_WITHOUT_PROPS);

export const GROUP_HIGHSCORES_LOAD_DEFAULT_ROUND = 'GROUP_HIGHSCORES_LOAD_DEFAULT_ROUND';
export const groupHighscoresLoadDefaultRound = actionCreator<string>(GROUP_HIGHSCORES_LOAD_DEFAULT_ROUND);

export const GROUP_HIGHSCORES_SET_IS_LOADING = 'GROUP_HIGHSCORES_SET_IS_LOADING';
export const groupHighscoresSetIsLoading = actionCreator<boolean>(GROUP_HIGHSCORES_SET_IS_LOADING);

export interface DefaultHighscoreRoundParams {
    ugId: string;
    tr: UserGroupDefaultHighscoreRound;
}

export const GROUP_HIGHSCORES_SET_DEFAULT_ROUND = 'GROUP_HIGHSCORES_SET_DEFAULT_ROUND';
export const groupHighscoresSetDefaultRound = actionCreator<DefaultHighscoreRoundParams>(GROUP_HIGHSCORES_SET_DEFAULT_ROUND);
